import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-75f3a6a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "profile__card" }
const _hoisted_2 = { class: "profile__card-info" }
const _hoisted_3 = { class: "profile__login" }
const _hoisted_4 = {
  key: 0,
  class: "preloading"
}
const _hoisted_5 = {
  key: 1,
  class: "stats__list"
}
const _hoisted_6 = { class: "stats__item" }
const _hoisted_7 = { class: "stats__count" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stats__name" }, "repositories", -1))
const _hoisted_9 = { class: "stats__item" }
const _hoisted_10 = { class: "stats__count" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stats__name" }, "following", -1))
const _hoisted_12 = { class: "profile__name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_PreloadRepo = _resolveComponent("PreloadRepo")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Avatar, {
      avatarUrl: $props.userInfo.avatarUrl,
      vClass: "profile",
      class: "profile__card-avatar"
    }, null, 8, ["avatarUrl"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString($props.userInfo.login), 1),
      (!$props.userInfo.repos && !$props.userInfo.following)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_PreloadRepo, {
              class: "preloader",
              type: "information"
            })
          ]))
        : (_openBlock(), _createElementBlock("ul", _hoisted_5, [
            _createElementVNode("li", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, _toDisplayString($props.userInfo.repos), 1),
              _createVNode(_component_router_link, {
                class: "stats__link",
                to: { name: 'repositories' }
              }, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, _toDisplayString($props.userInfo.following), 1),
              _createVNode(_component_router_link, {
                class: "stats__link",
                to: { name: 'following' }
              }, {
                default: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 1
              })
            ])
          ])),
      _createElementVNode("div", _hoisted_12, _toDisplayString($props.userInfo.name), 1)
    ])
  ]))
}